'use strict'

import getProjectDefinition from './getProjectDefinition.js';

export default function getProjectBrief(project) {
  var definition=getProjectDefinition(project);
  definition.scope.items=definition.scope.items!==undefined ? definition.scope.items.map(item=>({id:item.id,text:item.text})) : [];
  return {
    definition:definition,
    businessCase: project.businessCase,
    projectProductDescription: project.projectScope,
    organization: project.stakeholders!==undefined && project.stakeholders.length>0 ? project.stakeholders : undefined,
    approach: project.approach,
    version: project.brief!==undefined && project.brief.history!==undefined ? project.brief.history.length : 0
  }
}



// WEBPACK FOOTER //
// ./app/model/getProjectBrief.js